import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { REACT_APP_API_URL } from "../env";
import profile_av from "../assets/images/profile_av.png";

const ManagerProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(
          `${REACT_APP_API_URL}api/dashboard/admin/manager/profile`,
          { withCredentials: true }
        );

        if (response.data) {
          if (response.data.success && response.data.data) {
            setProfile(
              Array.isArray(response.data.data)
                ? response.data.data[0]
                : response.data.data
            );
          } else {
            setProfile(response.data);
          }
        }
      } catch (err) {
        setError("Failed to fetch profile information.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4">
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="p-4">
        <div className="alert alert-warning">No profile data found.</div>
      </div>
    );
  }

  return (
    <div className="page-body px-xl-8 px-sm-2 px-0 py-lg-2 py-1 mt-0 mt-lg-2">
      <div className="container-fluid">
        <div className="row g-3">
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h3 className="fw-bold text-gradient mb-0">Manager Profile</h3>
              <button
                className="btn btn-link p-0 me-2"
                onClick={() => navigate("/")}
              >
                
                <i className="bi bi-house fs-2 text-danger"></i>
              </button>
            </div>
          </div>

          <div className="col-lg-12 col-xl-12">
            <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
              <div className="card-body p-0">
                <div
                  className="p-5 text-center text-white position-relative"
                  style={{
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    minHeight: "200px",
                  }}
                >
                  <div
                    className="position-absolute start-50 translate-middle-x"
                    style={{ bottom: "-50px" }}
                  >
                    <img
                      src={profile_av}
                      alt="Profile"
                      className="rounded-circle border border-4 border-white shadow-lg"
                      style={{
                        width: "120px",
                        height: "120px",
                        objectFit: "cover",
                        backgroundColor: "#fff",
                      }}
                    />
                  </div>
                </div>

                {/* Profile Details */}
                <div className="pt-5 mt-4 px-4 pb-5">
                  <div className="text-center mb-5">
                    <h3 className="fw-bold mb-1">{profile.vchFullName}</h3>
                    <p className="text-muted mb-0">Manager</p>
                  </div>

                  <div className="row g-4 justify-content-center">
                    <div className="col-md-6 col-lg-5">
                      <div className="p-4 rounded-4 bg-light h-100 border border-light-subtle hover-lift transition-all">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="d-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 text-primary"
                            style={{ width: "45px", height: "45px" }}
                          >
                            <i className="bi bi-person-badge fs-4"></i>
                          </div>
                          <h6 className="ms-3 mb-0 fw-bold text-uppercase text-muted small letter-spacing">
                            Username
                          </h6>
                        </div>
                        <p className="fs-6 fw-semibold mb-0 text-dark">
                          {profile.vchUserName || "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-5">
                      <div className="p-4 rounded-4 bg-light h-100 border border-light-subtle hover-lift transition-all">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="d-flex align-items-center justify-content-center rounded-circle bg-success bg-opacity-10 text-success"
                            style={{ width: "45px", height: "45px" }}
                          >
                            <i className="bi bi-envelope fs-4"></i>
                          </div>
                          <h6 className="ms-3 mb-0 fw-bold text-uppercase text-muted small letter-spacing">
                            Email Address
                          </h6>
                        </div>
                        <p className="fs-6 fw-semibold mb-0 text-dark">
                          {profile.vchEmail || "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-5">
                      <div className="p-4 rounded-4 bg-light h-100 border border-light-subtle hover-lift transition-all">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="d-flex align-items-center justify-content-center rounded-circle bg-warning bg-opacity-10 text-warning"
                            style={{ width: "45px", height: "45px" }}
                          >
                            <i className="bi bi-telephone fs-4"></i>
                          </div>
                          <h6 className="ms-3 mb-0 fw-bold text-uppercase text-muted small letter-spacing">
                            Mobile Number
                          </h6>
                        </div>
                        <p className="fs-6 fw-semibold mb-0 text-dark">
                          {profile.vchMobTel || "N/A"}
                        </p>
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-5">
                      <div className="p-4 rounded-4 bg-light h-100 border border-light-subtle hover-lift transition-all">
                        <div className="d-flex align-items-center mb-3">
                          <div
                            className="d-flex align-items-center justify-content-center rounded-circle bg-info bg-opacity-10 text-info"
                            style={{ width: "45px", height: "45px" }}
                          >
                            <i className="bi bi-geo-alt fs-4"></i>
                          </div>
                          <h6 className="ms-3 mb-0 fw-bold text-uppercase text-muted small letter-spacing">
                            Address
                          </h6>
                        </div>
                        <p className="fs-6 fw-semibold mb-0 text-dark">
                          {profile.vchPreAddress || "N/A"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .hover-lift:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
        }
        .transition-all {
          transition: all 0.3s ease;
        }
        .letter-spacing {
          letter-spacing: 0.5px;
        }
        .text-gradient {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      `}</style>
    </div>
  );
};

export default ManagerProfile;
